import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { SignInResponseDto } from '@/model/generated';
import { api } from '@/utils/api';

export const useSubmitOtpCode = (usersPhone: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (OTPCode: string) => {
      const { challengeName, session } = (queryClient.getQueryData([
        'session',
      ]) || {}) as SignInResponseDto;
      return api.post<SignInResponseDto>('/sign-in/challenge', {
        challengeName,
        session,
        challengeResponses: {
          USERNAME: usersPhone,
          ANSWER: OTPCode,
        },
      });
    },
    onSuccess: ({ data }) => {
      if (data.challengeName) {
        queryClient.setQueryData(['session'], data);
      }
    },
  });
};
